import {Brand} from "@mytour/platform";
import {isCustomSubscriptionPrice} from "@mytour/shared";
import type {ReactNode} from "react";
import {Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import {CustomPrice} from "../components/CustomPrice";
import {DefaultPrice} from "../components/DefaultPrice";

type Props = {
  blocking: boolean;
  // Défauts = copy historique fin d'essai — le passage volontaire (#794) les
  // override pour ne plus parler de fin d'essai sur un compte encore en cours.
  title?: string;
  bodyText?: ReactNode;
  monthlyCentimes: number;
  yearlyCentimes: number;
  onRegister: (type: "monthly" | "yearly") => void;
  onDismiss: () => void;
};

export function EndOfTrialModal({
  blocking,
  title = "Fin de période d'essai",
  bodyText,
  monthlyCentimes,
  yearlyCentimes,
  onRegister,
  onDismiss,
}: Props) {
  const isCustom = isCustomSubscriptionPrice({monthlyCentimes, yearlyCentimes});

  return (
    <Modal
      isOpen={true}
      backdrop={blocking ? "static" : true}
      toggle={blocking ? undefined : onDismiss}
      autoFocus={false}
      centered
    >
      <ModalHeader
        close={blocking ? <></> : undefined}
        toggle={blocking ? undefined : onDismiss}
        className="mytour-header"
      >
        <Brand />
        {title}
      </ModalHeader>
      <ModalBody>
        <EndOfTrialBody bodyText={bodyText} />
      </ModalBody>
      <ModalFooter>
        <div style={{textAlign: "center", margin: "auto", width: "100%"}}>
          {isCustom ? (
            <CustomPrice
              monthlyCentimes={monthlyCentimes}
              yearlyCentimes={yearlyCentimes}
              onRegister={onRegister}
            />
          ) : (
            <DefaultPrice onRegister={onRegister} />
          )}
        </div>
      </ModalFooter>
    </Modal>
  );
}

function EndOfTrialBody({bodyText}: {bodyText?: ReactNode}) {
  return (
    <>
      <p style={{textAlign: "center"}}>{bodyText ?? <b>Période d'essai terminée !</b>}</p>
      <p style={{textAlign: "center"}}>
        {/* Markup historique préservé à l'identique quand bodyText est absent — un
            wording override ne doit changer que le paragraphe du dessus, jamais
            cette phrase ni le contact support, partagés par les deux parcours. */}
        {!bodyText && (
          <>
            {"Nous espérons que l'essai vous a donné satisfaction !"}
            <br />
            {
              "Pour continuer cette belle aventure ensemble, merci de choisir un abonnement qui vous convient."
            }
            <br />
            <br />
          </>
        )}
        {"Vous pouvez nous joindre à "}
        <a href="mailto:moderation.mytour@gmail.com?subject=Question au support MyTour">
          {"moderation.mytour@gmail.com"}
        </a>
      </p>
    </>
  );
}
